import type { FunctionComponent, ReactElement } from 'react';
import { useEffect } from 'react';

import { L10nText } from '../../../services/uiTranslations/reactBindings/L10nText';
import { CoreDispatch, useCoreDispatch } from '../../../store/CoreStore';
import { popupActions } from '../../../store/slices/popup/slice';
import { ButtonVariant } from '../../controls/button/Button';
import { Curtain } from '../../curtain/Curtain';
import { PopupType } from '../../popup/types';

import { BlockingModalActionButton, BlockingModalContent } from './BlockingModalContent';

interface GenericErrorConnectedProps {
  inCurtain?: boolean;
}

export const GenericErrorNoRefreshConnected: FunctionComponent<GenericErrorConnectedProps> = ({
  inCurtain,
}): ReactElement => {
  const dispatch: CoreDispatch = useCoreDispatch();

  const action: BlockingModalActionButton[] = [
    {
      label: <L10nText tk="OK" placeholder="OK" />,
      type: ButtonVariant.ACCENT,
      click: (): void => {
        dispatch(popupActions.dismissPopup(PopupType.GenericErrorNoRefresh));
      },
    },
  ];

  useEffect(() => {
    if (inCurtain) return;
    // Error may occur on initial loading. Remove curtain so that error popup is displayed
    Curtain.remove();
  }, [inCurtain]);

  return (
    <BlockingModalContent
      messageComponent={<L10nText tk="GENERIC_ERROR" placeholder="Please contact Customer Support for assistance" />}
      actions={action}
      inCurtain={inCurtain}
    />
  );
};
